/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react';
import Slider from "react-slick";
import { useTranslation } from 'react-i18next';
import { BlueLocationSvg, LocationChipSvg, NextSvg } from '../../common/svg/AllSvg';
import { dataActions } from '../../../shared/store/data-Slice';
import { useDispatch, useSelector } from 'react-redux';
import useAxios from '../../../shared/hooks/use-axios';
import { url } from '../../../shared/utils/url';
import { useParams } from 'react-router-dom';

const NearByAttractions = () => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [placeList, setPlaceList] = useState<any[]>([]);
    const { t } = useTranslation('common');
    const arrowRef: any = useRef(null);
    const dispatch = useDispatch();
    const params = useParams();

    const settings = {
        dots: false,
        variableWidth: true,
        arrows: false,
        infinite: placeList?.length > 3 ? true : false
    }

    const getVisitPlaces = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.tours}`);

            if (res && res?.status === 200) {
                let arr: any[] = []
                for (let i = 0; i < res?.data.length; i++) {
                    const el = res?.data[i];

                    if (el?.station?.code === params?.code) {
                        arr?.push(el)
                    }
                }
                setPlaceList(arr)
            }
        } catch (error) {
            console.error("error while feching near by attractions", error);
        }
    };

    useEffect(() => {
        (!!params?.code && !!lang) && getVisitPlaces();
    }, [lang, params?.code])

    return (
        <>
            {/* Near by Attractions places */}
            <div className='overflow-hidden pt-[50px] md:pt-[80px] xlx:pt-[100px] w-full h-full'>
                <div className='w-full h-full container flex gap-[50px] md:flex-row flex-col' id="nearby_attractions">
                    <div className='flex flex-col gap-[15px] md:w-auto w-full md:min-w-[300px] lg:min-w-[350px] xlx:min-w-[400px] md:mt-[40px]'>
                        <div className='flex items-center gap-[10px]'>
                            <BlueLocationSvg />
                            <h5 className='text-secPurple font-bold uppercase'>{t('passenger.station_detail.nearby_attractions')}</h5>
                        </div>
                        <div className="flex flex-col">
                            <h1 className="text-blackDull dark:text-textBlackDull font-bold max-w-[255px] md:max-w-max">{t('passenger.station_detail.gems.line1')}</h1>
                            <h1 className="text-primary font-bold">{t('passenger.station_detail.gems.line2')}</h1>
                        </div>
                        <h6 className='text-blackDull dark:text-textBlackDull font-normal max-w-[300px] xlx:max-w-[340px] mb-[20px]'>{t('passenger.station_detail.gems.line3')}</h6>

                        {/* <PrimaryBtn title={t("passenger.home.places.explore_now")} /> */}
                    </div>

                    <div className='relative'>
                        <Slider className='h-full flex w-[100vw]' ref={arrowRef} {...settings}>
                            {Array.isArray(placeList) && placeList?.map((item: any, index: number) => (
                                <div className="pr-[10px] lg:pr-[15px] xlx:pr-[20px] h-[400px] xlx:h-[410px]" key={index}>
                                    <button className="relative w-[235px] h-[350px] xlx:w-[245px] xlx:h-[360px] rounded-[20px] transition-all duration-100 hover:h-[390px] hover:xlx:h-[400px] focus:h-[390px] focus:xlx:h-[400px]" onClick={() => { dispatch(dataActions.setTourDetail(item)); dispatch(dataActions.setTourOpen(true)); }}>
                                        <div style={{ background: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 73.17%, #000 115.79%)" }} className="absolute rounded-[20px] top-0 left-0 right-0 bottom-0 w-full h-full p-[15px] xlx:px-[20px] xlx:py-[15px] flex flex-col justify-end gap-[4px] md:gap-[8px] xlx:gap-[10px]">
                                            <div className='flex gap-[5px]'>
                                                <LocationChipSvg />
                                                <h5 className='text-white font-bold text-left'>{item?.name}</h5>
                                            </div>
                                        </div>

                                        <img src={item?.photograph_mapping?.file} alt={item?.name} className="rounded-[20px] w-full h-full" />
                                    </button>
                                </div>
                            ))}
                        </Slider>

                        <div className='absolute top-0 left-0 bottom-0 flex items-center ml-[-20px] xlx:ml-[-25px] h-[350px]  xlx:h-[360px]'>
                            <button aria-label={t("aria_label.next_arr")}
                                title={t("aria_label.next")} onClick={() => arrowRef.current.slickNext()} className='min-w-[40px] xlx:min-w-[50px] h-[40px] xlx:h-[50px] flex items-center justify-center bg-primaryText rounded-full focus:shadow-[0_0_0_2px_#ffffff] hover:shadow-[0_0_0_2px_#ffffff]'><NextSvg /></button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NearByAttractions;